/**
 * Canonical Organization schema for RealEstateAgents.com
 * This should be the single source of truth for organization data across all pages
 *
 * NAP (Name, Address, Phone) Consistency:
 * - Brand: RealEstateAgents.com
 * - U.S. Legal Entity: ReferralExchange, Inc.
 * - Canada Legal Entity: Canada Referral Exchange Ltd.
 * - U.S. Address: PO Box 3634, Seattle, WA 98124-3634
 * - Canada Address: 210, 346 Leon Ave, Kelowna, BC V1Y 8C7
 * - Phone: +1 (888) 586-2349
 * - Email: support@realestateagents.com
 */

/**
 * Generate canonical Organization schema
 * @returns {Object} JSON-LD Organization schema object
 */
export function generateOrganizationSchema() {
  return {
    '@type': 'Organization',
    '@id': 'https://www.realestateagents.com/#organization',
    name: 'RealEstateAgents.com',
    legalName: 'ReferralExchange, Inc.',
    url: 'https://www.realestateagents.com/',
    logo: {
      '@type': 'ImageObject',
      url: 'https://www.realestateagents.com/static/rea-logo-with-text-black-white-background.webp',
    },
    parentOrganization: 'ReferralExchange, Inc.',
    foundingDate: '2005',
    sameAs: [
      'https://www.facebook.com/realestateagentsdotcom',
      'https://www.instagram.com/realestateagentsdotcom',
      'https://www.linkedin.com/company/realestateagents-com',
      'https://www.bbb.org/us/ca/san-francisco/profile/marketing-programs/referralexchange-inc-1116-458879',
      'https://www.shopperapproved.com/reviews/realestateagents.com',
    ],
    description:
      'The mission of RealEstateAgents.com is to make sure you actually enjoy the process of buying and selling your home. Continuous innovation keeps us at the forefront of next-gen real estate tech.',
    areaServed: [
      {
        '@type': 'Country',
        name: 'United States',
      },
      {
        '@type': 'Country',
        name: 'Canada',
      },
    ],
    address: [
      {
        '@type': 'PostalAddress',
        streetAddress: 'PO Box 3634',
        addressLocality: 'Seattle',
        addressRegion: 'WA',
        postalCode: '98124-3634',
        addressCountry: 'US',
      },
      {
        '@type': 'PostalAddress',
        streetAddress: '210, 346 Leon Ave',
        addressLocality: 'Kelowna',
        addressRegion: 'BC',
        postalCode: 'V1Y 8C7',
        addressCountry: 'CA',
      },
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+1(888)586-2349',
      email: 'support@realestateagents.com',
      contactType: 'customer service',
      areaServed: ['US', 'CA'],
      availableLanguage: ['en'],
    },
  };
}

/**
 * Generate WebSite schema
 * @returns {Object} JSON-LD WebSite schema object
 */
export function generateWebSiteSchema() {
  return {
    '@type': 'WebSite',
    '@id': 'https://www.realestateagents.com/#website',
    url: 'https://www.realestateagents.com/',
    name: 'RealEstateAgents.com',
    description:
      "RealEstateAgents.com is the best real estate agent recommendation service in the U.S. We've spent more than a decade observing the very best real estate agents in every market.",
    publisher: {
      '@id': 'https://www.realestateagents.com/#organization',
    },
    inLanguage: 'en-US',
  };
}
